import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IoMdClose } from 'react-icons/io';
import { IconButton } from '@mui/material';

export default function FundingModal({
  dialogTitle,
  dialogContentText,
  open,
  handleClose,
  onNotSave,
  onSave,
  isLoading
}) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClick={(event) => event.stopPropagation()}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 20px',
          }}
        >
          <DialogTitle id="alert-dialog-title" sx={{ padding: '0px' }}>
            {dialogTitle}
          </DialogTitle>
          <IconButton disabled={isLoading} onClick={handleClose}>
            <IoMdClose />
          </IconButton>
        </div>

        <DialogContent sx={{ paddingTop: 0 }}>
          <DialogContentText id="alert-dialog-description">{dialogContentText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              width: '100%',
              padding: '0px 10px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button variant="outlined" disabled={isLoading} sx={{ color: '#1976d2' }} onClick={handleClose}>
              Cancel
            </Button>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                variant="outlined"
                sx={{ color: '#1976d2' }}
                onClick={onNotSave}
                disabled={isLoading}
              >
                Don't Save
              </Button>
              <Button disabled={isLoading} variant="contained" onClick={onSave}>
                Save
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
